export function folding() {
	//サイド折りたたみメニュー
	jQuery(function ($) {
		//クリックのトリガー要素を指定
		$('.is-plus').on('click', function (e) {
			e.preventDefault();
			//隣接要素.next
			// $(this).parents('.c-menuSpHeader__list').find(".sub-menu").slideToggle(300);
			$(this).parents('.c-menuHeader__list').find(".c-subMenu").slideToggle(300);
			$(this).toggleClass('is-transform');
		});
	});
}